// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnorderedListOutlinedSvg from "@fishx/icons-svg/es/asn/UnorderedListOutlined";
import FishxIcon from '../components/FishxIcon';

var UnorderedListOutlined = function UnorderedListOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnorderedListOutlinedSvg
  }));
};

UnorderedListOutlined.displayName = 'UnorderedListOutlined';
export default React.forwardRef(UnorderedListOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UnorderedListOutlined.js
// module id = 4311
// module chunks = 0